import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Button } from "semantic-ui-react";
import { CURRENCY_SYMBOL } from "../../../constant";
import LoadingIcon from "../../../components/Loading/LoadingIcon";
import BalanceCardButton from "./balanceCardButton";
import Balance from "./balance";

const BalanceCard = ({ disabledCustomPath, hiddenTransferButton }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`profile.${key}`);

  const memberData = useSelector((state) => state.isMemberInfo);

  const navigate = useNavigate();

  return (
    <article className="flex flex-col gap-[10px]">
      <section className="py-[10px] px-[10px] bg-[#fab481] !bg-[#ff9b51] rounded-[5px] flex gap-[10px] items-center justify-between">
        <div className="flex items-center justify-between">
          <div className="flex flex-col justify-between">
            <Balance className="dark:text-base-white text-base-white !text-base" />
            <p className="text-white text-xs mb-0">{i18n("mainBalance")}</p>
          </div>
        </div>
        <div className="flex md:hidden items-center gap-[5px]">
          <BalanceCardButton
            customPath={
              disabledCustomPath
                ? false
                : {
                    depositPath: "deposit",
                    transferPath: "data/point-query",
                  }
            }
            hiddenTransferButton={hiddenTransferButton}
          />
        </div>
      </section>
      <section className="md:grid hidden grid-cols-2 gap-[10px]">
        <BalanceCardButton />
      </section>
    </article>
  );
};

export default BalanceCard;
